// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.secondary-title {
  font-size: 20px;
  font-weight: bold;
}

ion-checkbox {
  margin-right: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/information-and-security/game-settings/game-settings.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,iBAAA;AACJ;;AAEA;EACI,eAAA;AACJ","sourcesContent":[".secondary-title{\n    font-size: 20px;\n    font-weight: bold;\n}\n\nion-checkbox{\n    margin-right: 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
